import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, TrendingDownIcon } from 'lucide-react';
export function SocialProofSection() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿La guía incluye los horarios oficiales?',
    a: 'Sí, incluye la estructura del calendario y cómo afecta las rutas de transporte sugeridas.'
  }, {
    q: '¿Sirve si solo voy a los partidos en México?',
    a: 'Absolutamente, incluye secciones específicas de seguridad y transporte para CDMX, Monterrey y Guadalajara.'
  }, {
    q: '¿Es una suscripción?',
    a: 'No, es un pago único con acceso vitalicio a las actualizaciones de la guía hasta el pitazo inicial.'
  }];
  return <section className="py-24 bg-navy-900 relative" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        {/* Proof Stat Block */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-navy-800 to-navy-950 rounded-3xl p-8 md:p-12 border border-gold-500/20 shadow-2xl mb-24 flex flex-col md:flex-row items-center gap-12" data-id="element-165">
          <div className="flex-1 text-center md:text-left" data-id="element-166">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 uppercase" data-id="element-167">
              La Ventana de los <span className="text-gold-400" data-id="element-168">7 Días</span>
            </h2>
            <p className="text-lg text-slate-300 leading-relaxed" data-id="element-169">
              Al aplicar el sistema de "Clústeres de Eficiencia", un viajero
              promedio puede ahorrar hasta un 40% en vuelos internos y
              transporte logístico, asegurando su presencia en 3 partidos en 3
              sedes diferentes con el mismo presupuesto que otros gastan en solo
              una.
            </p>
          </div>

          <div className="flex-shrink-0 w-full md:w-auto flex flex-col items-center justify-center p-8 bg-navy-900 rounded-2xl border border-navy-700 shadow-inner" data-id="element-170">
            <TrendingDownIcon className="w-10 h-10 text-pitch-500 mb-2" data-id="element-171" />
            <span className="text-6xl font-bold text-white font-heading tracking-tighter mb-2" data-id="element-172">
              40%
            </span>
            <span className="text-sm text-slate-400 uppercase tracking-wider font-semibold text-center max-w-[150px]" data-id="element-173">
              Ahorro promedio en transporte
            </span>
          </div>
        </motion.div>

        {/* FAQ Section */}
        <div className="max-w-3xl mx-auto" data-id="element-174">
          <motion.h3 initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-3xl font-bold text-center text-white mb-12 uppercase tracking-wide" data-id="element-175">
            Preguntas Frecuentes
          </motion.h3>

          <div className="space-y-4" data-id="element-176">
            {faqs.map((faq, index) => {
            const isOpen = openFaqIndex === index;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="border border-navy-700 rounded-xl overflow-hidden bg-navy-800/50" data-id="element-177">
                  <button onClick={() => setOpenFaqIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none hover:bg-navy-800 transition-colors" data-id="element-178">
                    <span className="text-lg font-semibold text-white pr-4" data-id="element-179">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`w-5 h-5 text-gold-400 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-180" />
                  </button>

                  <AnimatePresence data-id="element-181">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-182">
                        <div className="px-6 pb-5 text-slate-300 leading-relaxed border-t border-navy-700/50 pt-4" data-id="element-183">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}